import React, { useContext } from "react";
import "./Footer.scss";
import { Fade } from "react-awesome-reveal";
import emoji from "react-easy-emoji";
import StyleContext from "../../contexts/StyleContext";
import * as CookieConsent from "vanilla-cookieconsent";

export default function Footer() {
  const { isDark } = useContext(StyleContext);
  return (
    <Fade bottom duration={1000} distance="5px">
      <div className="footer-div">
        <p className={isDark ? "dark-mode footer-text" : "footer-text"}>
          &nbsp;{emoji("Made with ❤️")} |&nbsp;
          <a href="imprint">Imprint</a>
          &nbsp;|&nbsp;
          <a href="privacy">Privacy</a>
          &nbsp;|&nbsp;
          <a
            href="#contact"
            onClick={($event) => {
              $event.preventDefault();
              CookieConsent.showPreferences();
            }}
          >
            Cookie settings
          </a>
        </p>
      </div>
    </Fade>
  );
}
